// Client name always leads task/work details, highlighted in brand red.
export const ClientTag = ({ client, className = "" }) =>
  client ? (
    <span className={`client-tag ${className}`} data-testid="client-tag" title={client}>{client}</span>
  ) : null;
